export default function getQuestions (entryId) {
    return new Promise((resolve, reject) => {
      const apiUrl = window.apiDomain ? window.apiDomain + 'api' : window.location.protocol + '//' + window.location.host + 'api';
      const methodUrl = `/quiz/${entryId}.json`;

      let request = new window.XMLHttpRequest();
      request.open('GET', apiUrl + methodUrl, true);

      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          let response = JSON.parse(request.response);

          if (Object.keys(response).length > 0) {
            this.setState({
              questionsData: response.questions,
              // Get slug to results entry
              resultsPageSlug: response.resultsPageSlug,
              totalQuestions: response.questions.length
            });
            resolve(response);
          } else {
            reject(response);
          }

        } else {
          // We reached our target server, but it returned an error
          // This is a little hacky
          this.setState ({
            questionsData: 'error',
            currentView: 'error'
          });
          reject({
            status: this.status,
            statusText: request.statusText
          });
        }
      }.bind(this);

      request.onerror = function () {
        reject({
          status: this.status,
          statusText: request.statusText
        });
      };

      request.send();
    });
  }
